import { render, staticRenderFns } from "./ConfigWebsiteCohorts.vue?vue&type=template&id=d4180aa8&scoped=true"
import script from "./ConfigWebsiteCohorts.vue?vue&type=script&lang=js"
export * from "./ConfigWebsiteCohorts.vue?vue&type=script&lang=js"
import style0 from "./ConfigWebsiteCohorts.vue?vue&type=style&index=0&id=d4180aa8&prod&lang=scss"
import style1 from "./ConfigWebsiteCohorts.vue?vue&type=style&index=1&id=d4180aa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4180aa8",
  null
  
)

export default component.exports